const LowBalanceEndMessages = [
    `I'll wait for a more detailed chat. Please <span class="chat-meta-link recharge" onclick="window.inChatMoengageEvt='Recharge Click in Chat'; document.getElementById('chat-action-bar-recharge-button').click()">recharge</span>  and connect`
]

export default LowBalanceEndMessages